import { useEffect, useRef, useState } from 'react';
import { Text, OtherProps } from '@chakra-ui/react';
import { ButtonText } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  text: string;
  noOfLines?: number;
  textStyle?: OtherProps['textStyle'];
}

/**
 * In this component by default we will show only 3 lines of text and View More button.
 * User clicks on View More button we will show whole text.
 */
const DisplayMultilineText = ({ text, noOfLines = 3, textStyle }: Props) => {
  const [isViewMoreActive, setIsViewMoreActive] = useState<boolean>(false);
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(
        textRef.current.scrollHeight > textRef.current.clientHeight
      );
    }
  }, [text]);

  return (
    <>
      <Text
        ref={textRef}
        textStyle={textStyle}
        overflow="hidden"
        textOverflow="ellipsis"
        noOfLines={isViewMoreActive ? undefined : noOfLines}
      >
        {text}
      </Text>

      {isOverflowing && (
        <ButtonText
          alignSelf="flex-start"
          iconLeft={
            <FontAwesomeIcon
              icon={isViewMoreActive ? faAngleUp : faAngleDown}
            />
          }
          onClick={() => setIsViewMoreActive(prevState => !prevState)}
        >
          View More
        </ButtonText>
      )}
    </>
  );
};

export default DisplayMultilineText;
